import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { IconButton } from '@material-ui/core';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(3),
  },
  title: {
    color: theme.palette.facet.accentBlue,
    fontSize: theme.typography.h1.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: 1,
  },
  dateRow: {
    display: 'flex',
    alignItems: 'center',
    width: '405px',
    justifyContent: 'space-between',
  },
  date: {
    color: theme.palette.primary.main,
    ...theme.typography.h4,
  },
  dateSelector: {
    display: 'flex',
    width: '75%',
    justifyContent: 'space-between',
  },
  dateSelectorButton: {
    padding: 0,
    color: theme.palette.facet.accentBlue,
  },
  todayButton: {
    minWidth: '85px',
    height: '27px',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.facet.primaryGray,
    ...theme.typography.body1,
  },
});


const ScheduleSectionTitle = ({
  className,
  classes,
  onIncrementDate,
  onDecrementDate,
  onResetDate,
  buttonText,
  formattedDate,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classNames(classes.title)}>
        Schedule
      </div>
      <div className={classNames(classes.dateRow)}>
        <div className={classes.dateSelector}>
          <IconButton onClick={onDecrementDate} className={classes.dateSelectorButton}>
            <KeyboardArrowLeftIcon />
          </IconButton>
          <div className={classNames(classes.date)}>
            {formattedDate}
          </div>
          <IconButton onClick={onIncrementDate} className={classes.dateSelectorButton}>
            <KeyboardArrowRightIcon />
          </IconButton>
        </div>
        <Button onClick={onResetDate} className={classNames(classes.todayButton)} variant="outlined">
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
ScheduleSectionTitle.defaultProps = {
  className: '',
};

ScheduleSectionTitle.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onIncrementDate: PropTypes.func.isRequired,
  onDecrementDate: PropTypes.func.isRequired,
  onResetDate: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  formattedDate: PropTypes.string.isRequired,
};

export default withStyles(styles)(ScheduleSectionTitle);
